<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">

            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cellsForExport" :data="exportDataList" worksheet="My Worksheet" name="responses">
              <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <el-table :default-expand-all="true" v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.regionName.toLowerCase().includes(search.toLowerCase()) ||
            data.dispAccidentNumber.toString().includes(search)
        )
          " style="width: 100%">
          <el-table-column :label="$t('Hadisə_nömrəsi')" sortable prop="dispAccidentNumber" width="200"></el-table-column>
          <el-table-column :label="$t('Qəza_komissarı')" sortable prop="accidentCommUserName" width="180"></el-table-column>
          <el-table-column :label="$t('Təyinat_dəyişdirilib')"  sortable prop="lstAccidentCommUserName"
            width="180"></el-table-column>
          <el-table-column :label="$t('Zəng_edən')" sortable prop="callPhone" width="150"></el-table-column>
          <el-table-column :label="$t('Zəng_tarixi')" sortable prop="callDateStr" width="150"></el-table-column>
          <el-table-column :label="$t('Sürücü')" sortable prop="driver" width="250"></el-table-column>
          <el-table-column :label="$t('Sürücü_məlumatı')" sortable prop="driverDescr" width="200"></el-table-column>
          <el-table-column :label="$t('Hadisə_məlumatları')" sortable prop="accidentDateStr" width="150"></el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" sortable prop="insuranceTypeName" width="150"></el-table-column>
          <el-table-column :label="$t('Şəxs_növü')" sortable prop="personTypeName" width="150"></el-table-column>
          <el-table-column :label="$t('SŞ')" sortable prop="policyNumber" width="150"></el-table-column>
          <el-table-column :label="$t('Region')" sortable prop="regionName" width="150"></el-table-column>
          <el-table-column :label="$t('Köhnə_DQN')" sortable prop="oldRegNumber" width="150"></el-table-column>
          <el-table-column :label="$t('Əmlaka_dəyən_zərər')" sortable prop="propertyStatusName" width="220"></el-table-column>
          <el-table-column :label="$t('Heyvana_dəyən_zərər')" sortable prop="animalStatusName" width="220"></el-table-column>
          <el-table-column :label="$t('İcbari_SŞ_başlama_tarixi')" sortable prop="startDateStr" width="220"></el-table-column>
          <el-table-column :label="$t('İcbari_SŞ_bitmə_tarixi')" sortable prop="endDateStr" width="200"></el-table-column>
          <el-table-column :label="$t('KASKO_SŞ_başlama_tarixi')" sortable prop="volStartDateStr"
            width="220"></el-table-column>
          <el-table-column :label="$t('KASKO_SŞ_bitmə_tarixi')" sortable prop="volEndDateStr" width="220"></el-table-column>
          <el-table-column :label="$t('FİN_&_VÖEN')" sortable prop="identNumber" width="150"></el-table-column>
          <el-table-column :label="$t('Yer')" sortable prop="place" width="150"></el-table-column>
          <el-table-column :label="$t('Sığortalı_adı')" sortable prop="insuredName" width="150"></el-table-column>
          <el-table-column :label="$t('Sığortalı_DQN')" sortable prop="regNumber" width="150"></el-table-column>
          <el-table-column :label="$t('Sığortalı_№')" sortable prop="phone" width="120"></el-table-column>
          <el-table-column :label="$t('Brand_model')" sortable prop="brandName" width="150"></el-table-column>
          <el-table-column :label="$t('Marka_model')" sortable prop="modelName" width="150"></el-table-column>
          <el-table-column :label="$t('Xəsarət_alan')" sortable prop="injuredStatusName" width="150"></el-table-column>
          <el-table-column :label="$t('Zəncirvari_qəza')" sortable prop="chainAccidentStatusName"
            width="150"></el-table-column>
          <el-table-column :label="$t('Marka_model')" sortable prop="customBrandModel" width="150"></el-table-column>
          <el-table-column :label="$t('Buraxılış_ili')" sortable prop="productionYear" width="120"></el-table-column>
          <el-table-column :label="$t('Təfərüat')" sortable prop="descr" width="200"></el-table-column>
          <el-table-column :label="$t('Filial')" sortable prop="branchName" width="150"></el-table-column>
          <el-table-column :label="$t('Oturacaq_sayı')" sortable prop="numberOfSeats" width="150"></el-table-column>
          <el-table-column :label="$t('Qeydiyyata_alan')" prop="createUserName" sortable width="170"></el-table-column>
          <el-table-column :label="$t('Hadisəyə_çıxış_statusu')" prop="needDepartureStatusName" sortable
            width="220"></el-table-column>
          <el-table-column :label="$t('Hadisəyə_çıxmama_səbəbi')" prop="departureNote" sortable width="220"></el-table-column>
          <el-table-column :label="$t('Yerində_tənzimlənmə_statusu')" prop="finishStatusName" sortable
            width="220"></el-table-column>
          <el-table-column :label="$t('Yerində_tənzimlənmə_səbəbi')" prop="finishReasonName" sortable
            width="220"></el-table-column>
          <el-table-column :label="$t('Yerində_tənzimlənmə_səbəbi_(Digər')" prop="otherFinishReason" sortable
            width="220"></el-table-column>
          <el-table-column :label="$t('Yerində_tənzimlənmə_qeydi')" prop="finishNote" sortable></el-table-column>



        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import {
  GetAccidentDetails,
} from "src/services/report";
export default {
  data() {
    return {
      loading: false,
      data: [],
      exportDataList: [],
      totalRecords: 0,
      search: "",
      uid: this.$store.state.user.id,
      item: {
        startDate: null,
        endDate: null,
        dataExport: 0,
        pageSize: 50,
        pageNumber: 1
      },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },

    };

  },
  computed: {
    cellsForExport() {
      let cells = {
        'Hadisə #': 'dispAccidentNumberExport',
        'Qəza komissarı': 'accidentCommUserName',
        'Təyinat dəyişdirilib': 'lastAccidentCommUserName',
        'Zəng edən': 'callPhone',
        'Zəng tarixi': 'callDateExport',

        'Sürücü': 'driver',
        'Sürücü məlumatı': 'driverDescr',
        'Hadisə tarixi': 'accidentDateExport',
        'Sığorta növü': 'insuranceTypeName',
        'Şəxs növü': 'personTypeName',
        'ŞŞ': 'policyNumber',
        'Region': 'regionName',
        'Köhnə DQN': 'oldRegNumber',
        'Əmlaka dəyən zərər': 'propertyStatusName',
        'Heyvana dəyən zərər': 'animalStatusName',
        'İcbari SŞ başlama tarixi': 'startDateExport',
        'İcbari SŞ bitmə tarixi': 'endDateExport',
        'KASKO SŞ başlama tarixi': 'volStartDateExport',
        'KASKO SŞ bitmə tarixi': 'volEndDateExport',
        'FİN & VÖEN': 'identNumber',
        'Yer': 'place',
        'Sığortalı adı': 'insuredName',
        'Sığortalı DQN': 'regNumber',
        'Sığortalı №': 'phone',
        'Brand model': 'brandName',
        'Marka model': 'modelName',
        'Xəsarət alan': 'injuredStatusName',
        'Zəncirvari qəza': 'chainAccidentStatusName',
        'Marka model': 'customBrandModel',
        'Buraxılış ili': 'productionYear',
        'Təfərüat': 'descr',
        'Filial': 'branchName',
        'Oturacaq sayı': 'numberOfSeats',
        'Qeydiyyata alan': 'createUserName',
        'Hadisəyə çıxış statusu': 'needDepartureStatusName',
        'Hadisəyə çıxmama səbəbi': 'departureNote',
        'Yerində tənzimlənmə statusu': 'finishStatusName',
        'Yerində tənzimlənmə səbəbi': 'finishReasonName',
        'Yerində tənzimlənmə səbəbi (Digər)': 'otherFinishReason',
        'Yerində tənzimlənmə qeydi': 'finishNote'

      };



      return cells;
    }
  },
  methods: {

    clickSearch() {
      this.filter.page = 1
      this.getData();
    },

    loadTime() {
      this.item.startDate = AddDays(new Date(), -1);
      this.item.endDate = new Date();
    },

    exportData() {
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.dataExport = 1;
      GetAccidentDetails(this.item).then((response) => {
        if (response.data) {
          this.exportDataList = response.data;
        }
      }).finally(() => {
        this.item.dataExport = 0;
      });
    },
    async getData() {
      this.loading = true;
      try {
        if (this.item.searchText === "") {
          this.item.searchText = null;
        }
        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          pageSize: this.filter.pagesize,
          pageNumber: this.filter.page,
          dataExport: this.item.dataExport
        };
        const response = await GetAccidentDetails(params);
        if (response.data) {
          this.data = response.data.map(item => ({
            ...item,
            dispAccidentNumberExport: item.dispAccidentNumber ? `${item.dispAccidentNumber.toString().padStart(7, '0')}\u200B` : '',
            accidentDateExport: item.accidentDate ? this.formatDateForExcel(new Date(item.accidentDate)) : '',
            callDateExport: item.callDate ? this.formatDateForExcel(new Date(item.callDate)) : '',
            startDateExport: item.startDate ? this.formatDateForExcel(new Date(item.startDate)) : '',
            endDateExport: item.endDate ? this.formatDateForExcel(new Date(item.endDate)) : '',
            volStartDateExport: item.volStartDate ? this.formatDateForExcel(new Date(item.volStartDate)) : '',
            volEndDateExport: item.volEndDate ? this.formatDateForExcel(new Date(item.volEndDate)) : '',
          }));
          this.displayData = this.data;
          this.totalRecords = response.data?.[0].totalRecords;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    formatDateForExcel(date) {
      // Eğer tarih değeri yoksa veya geçerli bir tarih değilse boş string döndür
      if (!date || new Date(date) === 'Invalid Date' || new Date(date).getFullYear() < 1971) {
        return '';
      }

      // Tarihi formatla
      const d = new Date(date);
      const pad = (num) => num.toString().padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
    ,
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },

    handleSizeChange(val) {
      this.filter.pagesize = val;
      this.getData();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>